export const STAFF_SCHEDULE_UPDATED_EVENT = "sbin:staff-schedule-updated";

const STAFF_SCHEDULE_VERSION_STORAGE_PREFIX = "sbin:staff-schedule-version:";

export function getStaffScheduleVersionStorageKey(salonId) {
  return `${STAFF_SCHEDULE_VERSION_STORAGE_PREFIX}${String(salonId || "")}`;
}

export function readStaffScheduleVersion(salonId) {
  if (typeof window === "undefined") return "";
  try {
    return window.localStorage.getItem(getStaffScheduleVersionStorageKey(salonId)) || "";
  } catch (_) {
    return "";
  }
}

export function publishStaffScheduleUpdate(salonId, detail = {}) {
  if (typeof window === "undefined") return "";
  const normalizedSalonId = String(salonId || "");
  const version = String(Date.now());
  try {
    window.localStorage.setItem(
      getStaffScheduleVersionStorageKey(normalizedSalonId),
      version
    );
  } catch (_) {
    // Ignore storage failures and still emit same-tab updates.
  }
  window.dispatchEvent(
    new CustomEvent(STAFF_SCHEDULE_UPDATED_EVENT, {
      detail: {
        ...detail,
        salonId: normalizedSalonId,
        version,
      },
    })
  );
  return version;
}
